export enum EndPoint {
  Login = '/auth/login',
  socialLogin = `/auth/social_login`,
  SignUp = '/auth/signup',
  Role = '/role',
  get_roles_by_role_id = '/get_roles_by_role_id',
  User = '/user',
  update_user_and_password = '/update_user_and_password',
  SchoolByCode = '/schoolByCode',
  School = '/school',
  get_multiple_schools_by_ids = '/get_multiple_schools_by_ids',
  Subject = '/subject',
  SubjectByIDs = '/subject_by_ids',
  Grade = '/grades',
  GradeByIDs = '/grades_by_ids',
  SchoolCalendar = '/school_calendar',
  SchoolCalendarBySchoolId = '/school_calendar_by_school_id',
  UserByRoleId = '/userByRoleId',
  UserByRoleIDS = '/get_user_by_role_ids',
  LessonPlan = '/lesson_plan',
  LessonPlanByUserId = '/lesson_plan_by_user_id',
  LessonPlanByIds = '/lesson_plan_by_ids',
  PacingPlan = '/pacing_plan',
  easy_questions = '/easy_questions',
  difficult_questions = '/difficult_questions',
  recommendation = '/recommendation',
  PacingPlanForManualClassroomByUserId = '/get_pacing_plan_for_manual_classroom_by_user_id',
  TeachersBySchoolId = '/get_teacher_by_school_id_4',
  UserProfileMedia = '/user_profile_media',
  Assignments = '/assignments',
  AssignmentType = '/assignment_type',
  AssignmentQuestionMedia = '/assignment_question_media',
  AssessmentQuestionMedia = '/assessment_question_media',
  AssignmentQuestion = '/assignment_questions',
  delete_bulk_questions_by_assignment_id = '/delete_bulk_questions_by_assignment_id',
  TeacherAssignments = '/teacher_assignments',
  StudentSubmittedAssignment = '/student_assignment',
  student_submitted_assignment_by_user_id_and_assignment_id = '/student_submitted_assignment_by_user_id_and_assignment_id',
  Evaluation = '/assingment_evaluation',
  assignment_evaluation_by_question_id_and_correctness = '/assignment_evaluation_by_question_id_and_correctness',
  AssignmentevaluationById = '/assignmentevaluationById',
  assignmentEvaluationByUserId = '/assignment_evaluation_by_user_id',
  getAssignmentsByUserId = '/assignmentByStudent',
  getAnswer = '/getCheckedAnswer',
  students_notes = '/students_notes',
  AssignmentQuestionByAssignmentId = '/assignment_questions_by_assignment_id',
  TeacherSubjectHours = '/teacher_subject_hours',
  teacher_subject_hours_by_dummy_user_id = '/teacher_subject_hours_by_dummy_user_id',
  update_multiple_teacher_periods = '/update_multiple_teacher_periods',
  TeacherSubjectHoursById = '/teacher_subject_hours_by_user_id',
  Student = '/stundent',
  student_extra_help = '/student_extra_help',
  student_extra_help_by_from_id = '/student_extra_help_by_from_id',
  deleteMultiplePacingPlan = '/delete_multiple_pacing_plan',
  deleteMultipleLessonPlans = '/delete_multiple_lesson_plan',
  get_lesson_plan_using_pacing_plan_id = '/get_lesson_plan_using_pacing_plan_id',
  classroom = '/classroom',
  StudentByClassroomId = '/student_by_classroom_id',
  students_notes_media = '/students_notes_media',
  update_multiple_pacing_plan = '/update_multiple_pacing_plan',
  user_by_role_and_school_id = '/user_by_role_and_school_id',
  StudentByUserId = '/student_by_user_id',
  Messages = '/messages',
  Messagemedia = '/message_media',
  classroom_by_classroom_codes = '/classroom_by_classroom_codes',
  lesson_plan_by_subject_user_id_pacing_plan_id = '/lesson_plan_by_subject_user_id_pacing_plan_id',
  lesson_plan_media = '/lesson_plan_media',
  classroom_by_subject_and_grade = '/classroom_by_subject_and_grade',
  teacher_lesson_plan = '/teacher_lesson_plan',
  teacher_lesson_plan_by_user_id = '/teacher_lesson_plan_by_user_id',
  lesson_plan_rankings = '/lesson_plan_rankings',
  lesson_plan_rankings_by_teacher_lesson_plan_ids = '/lesson_plan_rankings_by_teacher_lesson_plan_ids',
  teacher_pacing_plan = '/teacher_pacing_plan',
  update_multiple_teacher_pacing_plans_events = '/update_multiple_teacher_pacing_plans_events',
  update_multiple_teacher_lesson_plan = '/update_multiple_teacher_lesson_plan',
  Documents = '/documents',
  Archive = '/archive',
  AddMultipleMessages = '/add_multiple_messages',
  DeleteMultipleMessages = '/delete_messages',
  Request = '/request',
  RequestReciept = '/request_reciept',
  Email = '/email/send-email',
  BulkEmail = '/email/send-all-email',
  GlobalPacingPlan = '/global_pacing_plan',
  GetAllUsersByRoleId = '/get_all_users_by_role_id',
  documents_media = '/documents_media',
  feedback_media = '/feedback_media',
  AdminSchoolEvents = '/admin_school_events',
  user_by_school_id_role_id_and_email = '/user_by_school_id_role_id_and_email',
  upcoming_admin_events = '/upcoming_admin_events',
  user_by_role_id = '/user_by_role_id',
  notifications = '/notifications',
  add_multiple_notifications = '/add_multiple_notifications',
  update_multiple_notifications = '/update_multiple_notifications',
  delete_global_pacing_plan_by_subject_grade = '/delete_global_pacing_plan_by_subject_grade',
  messages_users_by_last_message_id = '/messages_users_by_last_message_id',
  parents_messages_users = '/parents_messages_users',
  parent_messages_student = '/get_parent_of_student',
  LastMessageOfCurrentUser = '/get_last_message',
  lesson_plan_by_pacing_plan_id = '/lesson_plan_by_pacing_plan_id',
  teacher_lesson_plan_by_subject_id_and_grades_id = '/teacher_lesson_plan_by_subject_id_and_grades_id',
  teacher_bell_shedules = '/teacher_bell_shedules',
  get_all_users = '/get_all_users',
  UserTimeSession = '/time_management',
  teacher_lesson_plan_by_date_subject_id = '/teacher_lesson_plan_by_date_subject_id',
  assignments_by_user_id_and_time = '/assignments_by_user_id_and_time',
  student_teacher_lesson_plan = '/student_teacher_lesson_plan',
  assignment_by_classroom_subject_id = '/assignment_by_classroom_subject_id',
  assignment_questions_by_assignements_id = '/assignment_questions_by_assignements_id',
  assignments_by_classroom_id = '/assignments_by_classroom_id',
  student_assignment_by_assignments_id_user_id = '/student_assignment_by_assignments_id_user_id',
  student_extra_help_by_student_and_correctness = '/student_extra_help_by_student_and_correctness',
  Feedback = '/feedback',
  power_up_pointer = '/power_up_pointer',
  student_extra_help_solution = '/student_extra_help_solution',
  student_by_student_code = '/student_by_student_code',
  parent_user_by_email = '/parent_user_by_email',
  user_by_identity_code = '/user_by_identity_code',
  user_by_email = '/user_by_email',
  user_by_student_codes = '/user_by_student_codes',
  power_up_points_by_role_id = '/power_up_points_by_role_id',
  power_up_points_by_students_ids = '/power_up_points_by_students_ids',
  add_multiple_users = '/add_multiple_users',
  get_all_users_by_email = '/get_all_users_by_email',
  check_user_with_email_case = '/check_user_with_email_case',
  school_bell_shedules = '/school_bell_shedules',
  school_logo = '/school_logo',
  students_and_assignments_academic_progress = '/students_and_assignments_academic_progress',
  add_multiple_students = '/add_multiple_students',
  user_by_multiple_role_and_school_ids = '/user_by_multiple_role_and_school_ids',
  parent_student_management = '/parent_student_management',
  delete_multiple_parent_student_management = '/delete_multiple_parent_student_management',
  parent_student_management_post_single = '/parent_student_management_post_single',
  users_by_role_id_classroom_id_messages = '/users_by_role_id_classroom_id_messages',
  students_school_transfer = '/students_school_transfer',
  delete_student_by_user_id = '/delete_student_by_user_id',
  get_student_by_user_id_and_patch = '/get_student_by_user_id_and_patch',
  tutorial_videos = '/tutorial_videos',
  bulk_upload_process = '/bulk_upload_process',
  bulk_upload_process_delete = '/bulk_upload_process_delete',
  students_school_transfer_using_user_id = '/students_school_transfer_using_user_id',
  teacher_lesson_plan_by_lesson_plan_ids = '/teacher_lesson_plan_by_lesson_plan_ids',
  teacher_lesson_plan_by_days = '/teacher_lesson_plan_by_days',
  add_multiple_bell_schedule = '/add_multiple_bell_schedule',
  delete_difficult_and_easy_questions = '/delete_difficult_and_easy_questions',
  delete_multiple_teacher_lesson_plans = '/delete_multiple_teacher_lesson_plans',
  get_recommendation_by_grade_id_and_subject_id = '/get_recommendation_by_grade_id_and_subject_id',
  openai_assistant = '/help_assistant',
  get_recommendations_by_subject_and_class = '/get_recommendations_by_subject_and_class',
  global_pacing_plans_by_ids = '/global_pacing_plans_by_ids',
  teacher_assesment = '/teacher_assesment',
  add_multiple_assessment_questions = '/add_multiple_assessment_questions',
  get_student_teacher_assesment = '/get_student_teacher_assesment',
  // 'teacher_assessment_by_assessment_id' = '/teacher_assesment',
  get_assessment_by_teacher_assessment_id = '/get_assessment_by_teacher_assessment_id',
  students_submitted_assessment = '/students_submitted_assessment',
  assessment_question_evaluation = '/assessment_question_evaluation',
  teacher_activated_assessments = '/teacher_activated_assessments',
  get_multiple_pacing_plan_by_ids = '/get_multiple_pacing_plan_by_ids',
  assessment_question_student_note = '/assessment_question_student_note',
  assesment_questions = '/assesment_questions',
  previous_question_student_note = '/previous_question_student_note',
  check_if_student_submitted_assessment = '/check_if_student_submitted_assessment',
  sendUserEmail = '/send-user-email',
  sendAllUserEmail = '/send-all-email',
  user_sign_up = '/user_sign_up',
  getDisableusers = '/user_by_disabled_state',
  student_progress = '/student_progress',
  update_multiple_classrooms = '/update_multiple_classrooms',
  teacher_assesment_for_evaluation = '/teacher_assesment_for_evaluation',
  classroom_by_user_id = '/classroom_by_user_id',
  check_if_user_is_logged_in = '/check_if_user_is_logged_in',
  mock_school_data = '/mock_school_data',
  tokens_used = '/tokens_used',
  dummy_users = '/dummy_users',
  getStudentWithClassrooms = '/getStudentWithClassrooms',
  delete_trial_user_data = '/delete_trial_user_data',
  user_count_per_role_id = '/user_count_per_role_id',
  email_token_verification = '/email_token_verification',
  get_email_token_verification = '/get_email_token_verification',
  mindful_coach = '/mindful_coach',
  delete_multiple_message_threads = '/delete_multiple_message_threads',
  users_by_classroom_ids = '/users_by_classroom_ids',
  custom_pacing_plans = '/manual_pacing_plans',
  custom_pacing_plans_test_review_days = '/manual_pacing_plans_test_review_days',
  teacher_custom_pacing_plans = '/teacher_custom_pacing_plans',
  subscription_log_table = '/subscription_log_table',
  get_all_documents = '/get_all_documents',
  custom_global_pacing_plan = '/custom_global_pacing_plan',
  get_previously_asked_students_question = '/get_previously_asked_students_question',
  disabel_multiple_user = '/disabel_multiple_user',
  add_multiple_custom_global_pacing_plans = '/add_multiple_custom_global_pacing_plans',
  add_multiple_teacher_pacing_plans = '/add_multiple_teacher_pacing_plans',
  delete_multiple_teacher_pacing_plans = '/delete_multiple_teacher_pacing_plans',
  update_global_pacing_plan_data = '/update_global_pacing_plan',
  get_all_teachers_list = '/get_all_teachers_list',
  add_multiple_custom_pacing_plans = '/add_multiple_custom_pacing_plans',
  add_multiple_custom_pacing_plans_test_and_review_days = '/add_multiple_custom_pacing_plans_test_and_review_days',
  get_all_previous_year_assesment = '/get_all_previous_year_assesment',
  get_all_previous_year_assignment = '/get_all_previous_year_assignment',
  add_multiple_assignment_question = '/add_multiple_assignment_question',
  disable_multiple_user = '/disable_multiple_user',
  teacher_academic_information = '/teacher_academic_information',
  update_teacher_academic_information = '/update_teacher_academic_information',
  academic_information_by_calendar_and_user_id = '/academic_information_by_calendar_and_user_id',
  get_empty_teacher_subject_hours = '/get_empty_teacher_subject_hours',
  delete_trial_user = '/email/delete-trial-user',
  getAllNotificationsByUserId = '/getAllNotificationsByUserId',
  deleted_test_review_days = '/deleted_test_review_days',
  get_multiple_bell_schedules_by_id = '/get_multiple_bell_schedules_by_id',
  school_update_faculty_status_code = '/school_update_faculty_status_code',
  teacher_lesson_plan_per_day = '/teacher_lesson_plan_per_day',
  deleted_teacher_standard_dates = '/deleted_teacher_standard_dates',
  deleted_teacher_standard_dates_delete_using_ids = '/deleted_teacher_standard_dates_delete_using_ids',
  add_bulk_pacing_plan_records = '/add_bulk_pacing_plan_records',
  add_bulk_test_and_review_records = '/add_bulk_test_and_review_records',
  user_activity_log = '/user_activity_log',
  activity_status = '/update_activity_data_by_user_id',
  get_unarchive_classroom_list_by_user_id = '/get_unarchived_classroom_list_by_user_id',
  teacher_lesson_plan_by_user_and_classroom_id = '/teacher_lesson_plan_by_user_and_classroom_id',
  teacher_lesson_plan_by_classroom_ids = '/teacher_lesson_plan_by_classroom_ids',
  update_multiple_teacher_pacing_plans = '/update_multiple_teacher_pacing_plans',
  get_student_list_by_classroom_code = '/get_student_list_by_classroom_code',
  teacher_evaluation = '/teacher_evaluation',
  school_teacher_evaluation_structure = '/school_teacher_evaluation_structure',
  get_teachers_by_school_id = '/get_teacher_by_school_id',
  get_assessment_and_assignment_data_by_student_id = '/get_assessment_and_assignment_data_by_student_id',
  check_user_with_email_case_and_uid = '/check_user_with_email_case_and_uid',
  teacher_only_user = '/teacher_only_user',
  merge_teacher_only_data_with_real_school = '/merge_teacher_only_data_with_real_school',
  get_assessment_mastery_calculation = `/get_assessment_mastery_calculation`,
  validate_document_number = `/teacher-credential/scrape`,
  store_credential_data = '/essa_grid',
  get_users_by_role_id_and_school_id = '/get_users_by-role_id_and_school_id',
  auto_populate_classrooms = '/auto_populate_classrooms',
  get_auto_classroom_data_by_classroom_id = '/get_auto_classroom_data_by_classroom_id',
  lcap_reports_data = '/lcap_reports',
  lcap_school_data = '/lcap/retrive-school-list',
  lcap_scrape = `/lcap/scrape`,
  lcap_template_data = '/lcap_template_data',
  get_lcap_scrap_data = '/get_lcap_scrap_data',
  caaspp_school_list = '/get_caaspp_school_list_by_name_and_list',
  caaspp_scrape = `/caaspp/scrape`,
  caaspp_scrape_alternate_english = `/caaspp/scrape/alternate_english`,
  caaspp_scrape_science = `/caaspp/scrape/science`,
  elpac_scrape = `/caaspp/scrape/initial_elpac`,
  signup_activity = '/tracking_signup_activity',
  update_bulk_teachers_login_status = '/update_bulk_teachers_login_status',
  admin_survey = '/admin_survey',
  climate_survey_question_bank = '/climate_survey_question_bank',
  get_admin_survey_by_id = '/get_admin_survey_by_id',
  ai_credits_usage = '/ai_credits_usage',
  check_if_survey_shared_with_user = '/check_if_survey_shared_with_user',
  user_submitted_climate_surveys = '/user_submitted_climate_surveys',
  check_if_user_already_filled_survey = '/check_if_user_already_filled_survey',
  get_archive_admin_survey = '/get_archive_admin_survey',
  get_submitted_survey_by_id = '/get_submitted_survey_by_id',
  teacher_payment = '/payment/checkout',
  create_stripe_customer = '/payment/create-customer',
  validate_subscription = '/payment/validate-subscription',
  check_subscription_by_user_id = '/check_subscription_by_user_id',
  cancel_subscription = '/payment/cancel-subscription',
  get_pacing_plan_list_by_subject_and_grades_id = '/get_pacing_plan_list_by_subject_and_grades_id',
  update_user_last_subscription_plan = '/update_user_last_subscription_plan',
  easy_questions_by_id = '/easy_questions_by_id',
  difficult_questions_by_id = '/difficult_questions_by_id',
  get_classroom_by_pages = '/get_classroom_by_pages',
  classroom_by_classroom_codes_by_pages = '/classroom_by_classroom_codes_by_pages',
  teacher_lesson_plan_rankings = '/teacher_lesson_plan_rankings',
  teacher_lesson_plan_version_exists = '/teacher_lesson_plan_version_exists',
  get_all_sent_notifications_to_user = '/get_all_sent_notifications_to_user',
  get_student_assignment_data_for_summary = '/get_student_assignment_data_for_summary',
  get_previous_assignments_for_student = '/get_previous_assignments_for_student',
  take_home_project = '/take_home_project',
  get_home_projects_by_user_and_classroom = '/get_home_projects_by_user_and_classroom',
  get_home_projects_by_classroom_and_subject = '/get_home_project_by_classroom_and_subject',
  get_students_project_data = '/get_students_project_data',
  get_lcap_records_by_user_id = '/get_lcap_records_by_user_id',
  students_submitted_projects = '/students_submitted_projects',
  student_parent_by_classroom_code = '/student_parent_by_classroom_code',
  update_multiple_admin_school_events = '/update_multiple_admin_school_events',
  check_if_cds_number_exist = '/check_if_cds_number_exist',
  get_classrooms_of_students = '/get_classrooms_of_students',
  send_remainder_email = '/send-remainder-email',
  get_saved_answer_of_student_assignment = '/get_saved_answer_of_student_assignment',
  update_saved_answer_of_student_assignment = '/update_saved_answer_of_student_assignment',
  get_assignment_evaluation = '/get_assignment_evaluation',
  student_assignment_by_assignment_id = '/student_assignment_by_assignment_id',
  get_student_academic_details = '/get_student_academic_details',
  get_student_assessmant_data_for_summary = '/get_student_assessment_data_for_summary',
  get_completed_lesson_plan_of_teachers = '/get_completed_lesson_plan_of_teachers',
  get_take_home_project_by_privacy_id = '/get_take_home_project_by_privacy_id',
  add_assignment_questions_in_bulk = '/add_assignment_questions_in_bulk',
  get_assignment_data_by_subject_and_grade = '/get_assignment_data_by_subject_and_grade',
  get_assignment_questions_for_question_bank = '/get_assignment_questions_for_question_bank',
  get_users_by_school_id = '/get_users_by_school_id',
  get_assessment_questions_by_standards_for_question_bank = '/get_assessment_questions_by_standards_for_question_bank',
  get_assessment_questions_by_pacing_plan = '/get_assessment_questions_by_pacing_plan',
  get_academic_year_data_by_school_id = '/get_academic_year_data_by_school_id',
  update_multiple_user_academic_year_highlights_by_school_id = '/update_multiple_user_academic_year_highlights',
  check_student_classroom_overlap = '/check_student_classroom_overlap',
  google_analytics_run_report = '/google/run-report',
  google_analytics_token = '/google/token',
  google_analytics_realtime = '/google/realtime-analytics',
  delete_homework_assignment = '/delete_homework_assignment',
  deleted_custom_pacing_plans_using_ids = '/deleted_custom_pacing_plans_using_ids',
  upcoming_events = '/upcoming_events'
}
